'use strict';

var isMini = require('../utils/is_mini');
// const isIOS = require('../utils/is_ios');
module.exports = function (link) {
  // UC Mini不支持scheme协议唤起
  if (!isMini()) {
    var ifr = document.createElement('iframe');
    ifr.src = link;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    setTimeout(function () {
      document.body.removeChild(ifr);
    }, 2000);
  }
};